import React from "react";

import { TextInput, TextInputProps } from "react-admin";

const SearchInput = (props: TextInputProps) => {
  return (
    <TextInput
      {...props}
      onKeyDown={(e) => {
        if (e.key === "Esc" || e.key === "Escape") {
          if (e.target instanceof HTMLInputElement) {
            // Yeah, this is apparently how you can set the DOM element value to "" and notify React about it
            // (see https://stackoverflow.com/questions/23892547/what-is-the-best-way-to-trigger-onchange-event-in-react-js)
            const input = e.target;
            const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
              window.HTMLInputElement.prototype,
              "value"
            )?.set;
            nativeInputValueSetter?.call(input, "");

            const evt = new Event("input", { bubbles: true });
            input.dispatchEvent(evt);
          }
        }
      }}
    />
  );
};

export default SearchInput;
